export const fullUrlToInternalLink = (url) =>
  url.replace("https://python-graph-gallery.com", "");
